<template>
  <div>
    <alert
      v-if="alertVisible"
      :message="alertMessage"
      :type="alertType">
    </alert>
    <main-layout
      controlsBg="light"
      customControls
      :hasControlsBar="false"
      :breadcrumb="getBreadcrumb">
      <div class="container">
        <grid-row column-align="center">
          <grid-col col-size="4">
            <div class="header-wrapper margin-top-xl margin-bottom-xxl">
              <div class="title-wrapper">
                <h1 class="header header-title">
                  <chevron
                    @click="$router.push({name: 'Workspace'})"/>
                  {{ $t('menu.gpxIngest') }}
                </h1>
              </div>
            </div>
          </grid-col>
        </grid-row>

        <grid-row
          column-align="center">
          <grid-col
            col-size="4">
            <h2
              class="margin-bottom-s">
            </h2>
            <p>&#128196; {{ $t('health.gpxIngestFile') }}</p>
          </grid-col>
        </grid-row>

        <grid-row column-align="center">
          <grid-col col-size="4">
            <div>
              <btn-input-file
                class="button-uploader"
                btn-text="upload"
                btn-size="s"
                accept=".gpx"
                @change="uploadGpx"/>
            </div>
          </grid-col>
        </grid-row>
      </div>
    </main-layout>
  </div>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import BtnInputFile from '@/components/shared/buttons/BtnInputFile';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import Alert from '@/components/shared/alert/Alert';
import Chevron from '@/components/shared/Chevron';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Radio from '@/components/shared/forms/Radio';
import AddUserModal from '@/components/group/AddUserModal';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import {faUsers} from '@fortawesome/pro-regular-svg-icons';

import userApi from '@/api/user';
import GpxIngest from 'BRAND/api/GpxIngest';

export default {
  name: 'FoodCompositionCsvIngest',
  components: {

    AddUserModal,
    Radio,
    BtnPill,
    Chevron,
    MainLayout,
    GridRow,
    GridCol,
    BtnInputFile,
    Alert,
    FontAwesomeIcon
  },
  data () {
    return {
      showModal: false,
      selectedMode: 'system',
      selectedUser: null,
      users: [],
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '', // error, warning, success
      icon: {
        users: faUsers
      }
    };
  },
  created () {
    userApi.getUsers(this).then((users) => {
      this.users = users.filter(user => user.enabled);
    });
  },
  computed: {
    getBreadcrumb () {
      return [
        {name: this.$t('menu.workspace'), link: '/workspace'},
        {name: this.$t('menu.gpxIngest'), disabled: true}
      ];
    }
  },
  methods: {
    uploadGpx (event) {
      const file = event.target.files[0];

      GpxIngest.uploadGpxForUser(this, file)
        .then(() => this.showAlert('OK', 'success'))
        .catch((error) => this.showAlert(error.data.message, 'error'));
    },

    showAlert (message, type) {
      this.alertVisible = true;
      this.alertMessage = message;
      this.alertType = type;
      setTimeout(() => {
        this.alertVisible = false;
      }, 2000);
    }
  }
};
</script>

<style lang="scss">
@import "src/stylesheets/variables";
</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/GpxIngest.vue